export default __webpack_public_path__ + "bg_anli_zhaopin0155e921.png";